import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {IVendorOfferWithoutVendorConfiguration} from "../../../offer/types/VendorOffersListResponse";
import {generalSectionStyle} from "../../views/VendorDetailView";
import {VendorDetailUnavailableOfferBox} from "./boxes/VendorDetailUnavailableOfferBox";

interface IProps {
    title: string;
    vendorSlug: string;
    offers: IVendorOfferWithoutVendorConfiguration[];
    isFetching: boolean;
    count: number;
    page: number;
    pageSize: number;
    onLoadMore: () => void;
    onReset: () => void;
    type: "archive" | "inactive";
}

export const UnavailableOffersList: React.FC<IProps> = ({title, vendorSlug, offers, isFetching, count, page, pageSize, onLoadMore, onReset, type}) => {
    if (count <= 0 && !isFetching) {
        return null;
    }

    return (
        <section className={generalSectionStyle}>
            {count > 0 && (
                <Text as="h2" variant="headline_3" className={headingStyle}>
                    {title}
                </Text>
            )}

            {offers.length > 0 && (
                <ul className={listStyle}>
                    {offers.map((offer) => (
                        <li key={offer.id} className={listItemStyle}>
                            <VendorDetailUnavailableOfferBox offer={offer} vendorSlug={vendorSlug} type={type} />
                        </li>
                    ))}
                </ul>
            )}

            <div className={css({pt: 2})}>
                {isFetching && <Loader size="md" className={loaderStyle} />}

                {!isFetching && count > pageSize * page && (
                    <Button variant="highlight_primary" onClick={onLoadMore}>
                        Zobacz więcej
                    </Button>
                )}

                {count > pageSize && count <= pageSize * page && (
                    <Button variant="highlight_primary" onClick={onReset}>
                        Pokaż mniej
                    </Button>
                )}
            </div>
        </section>
    );
};

const headingStyle = css({
    marginBottom: 0.5
});

const listStyle = css({
    listStyle: "none",
    paddingLeft: 0,
    margin: 0
});

const listItemStyle = css({
    marginTop: 2,
    marginBottom: 2,
    md: {
        marginTop: 3,
        marginBottom: 3
    }
});

const loaderStyle = css({
    display: "flex",
    justifyContent: "center",
    marginTop: 3,
    marginBottom: 3
});
import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {IVendorOfferWithoutVendorConfiguration} from "../../../offer/types/VendorOffersListResponse";
import {generalSectionStyle} from "../../views/VendorDetailView";
import {VendorDetailUnavailableOfferBox} from "./boxes/VendorDetailUnavailableOfferBox";

interface IProps {
    title: string;
    vendorSlug: string;
    offers: IVendorOfferWithoutVendorConfiguration[];
    isFetching: boolean;
    count: number;
    page: number;
    pageSize: number;
    onLoadMore: () => void;
    onReset: () => void;
    type: "archive" | "inactive";
}

export const UnavailableOffersList: React.FC<IProps> = ({title, vendorSlug, offers, isFetching, count, page, pageSize, onLoadMore, onReset, type}) => {
    if (count <= 0 && !isFetching) {
        return null;
    }

    return (
        <section className={generalSectionStyle}>
            {count > 0 && (
                <Text as="h2" variant="headline_3" className={headingStyle}>
                    {title}
                </Text>
            )}

            {offers.length > 0 && (
                <ul className={listStyle}>
                    {offers.map((offer) => (
                        <li key={offer.id} className={listItemStyle}>
                            <VendorDetailUnavailableOfferBox offer={offer} vendorSlug={vendorSlug} type={type} />
                        </li>
                    ))}
                </ul>
            )}

            <div className={css({pt: 2})}>
                {isFetching && <Loader size="md" className={loaderStyle} />}

                {!isFetching && count > pageSize * page && (
                    <Button variant="highlight_primary" onClick={onLoadMore}>
                        Zobacz więcej
                    </Button>
                )}

                {count > pageSize && count <= pageSize * page && (
                    <Button variant="highlight_primary" onClick={onReset}>
                        Pokaż mniej
                    </Button>
                )}
            </div>
        </section>
    );
};

const headingStyle = css({
    marginBottom: 0.5
});

const listStyle = css({
    listStyle: "none",
    paddingLeft: 0,
    margin: 0
});

const listItemStyle = css({
    marginTop: 2,
    marginBottom: 2,
    md: {
        marginTop: 3,
        marginBottom: 3
    }
});

const loaderStyle = css({
    display: "flex",
    justifyContent: "center",
    marginTop: 3,
    marginBottom: 3
});
